var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17V3C7 1.896 7.896 1 9 1H31L39 9V37C39 38.104 38.104 39 37 39H9C7.896 39 7 38.104 7 37V31",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10H30V4",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31H3C1.896 31 1 30.104 1 29V19C1 17.896 1.896 17 3 17H24C25.104 17 26 17.896 26 19V29C26 30.104 25.104 31 24 31Z",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 28V19.9H8.32C8.80667 19.9 9.20667 19.9933 9.52 20.18C9.83333 20.36 10.0667 20.6267 10.22 20.98C10.3733 21.3267 10.45 21.75 10.45 22.25C10.45 22.8767 10.3467 23.3567 10.14 23.69C9.93333 24.0167 9.65333 24.2433 9.3 24.37C8.94667 24.4967 8.55 24.56 8.11 24.56H7.39V28H5.6ZM7.39 23.31H7.99C8.21 23.31 8.37667 23.27 8.49 23.19C8.60333 23.11 8.67667 22.99 8.71 22.83C8.75 22.67 8.77 22.4667 8.77 22.22C8.77 22.0133 8.75333 21.8333 8.72 21.68C8.69333 21.52 8.62333 21.3933 8.51 21.3C8.39667 21.2067 8.22 21.16 7.98 21.16H7.39V23.31ZM11.7348 28V19.9H13.7848C14.4914 19.9 15.0414 19.99 15.4348 20.17C15.8281 20.3433 16.1048 20.62 16.2648 21C16.4248 21.3733 16.5048 21.86 16.5048 22.46V25.4C16.5048 26.0067 16.4248 26.5033 16.2648 26.89C16.1048 27.27 15.8281 27.55 15.4348 27.73C15.0481 27.91 14.5048 28 13.8048 28H11.7348ZM13.5248 26.76H13.8048C14.0781 26.76 14.2748 26.72 14.3948 26.64C14.5148 26.56 14.5881 26.44 14.6148 26.28C14.6481 26.12 14.6648 25.92 14.6648 25.68V22.15C14.6648 21.91 14.6448 21.7167 14.6048 21.57C14.5714 21.4233 14.4948 21.3167 14.3748 21.25C14.2548 21.1833 14.0614 21.15 13.7948 21.15H13.5248V26.76ZM18.0941 28V19.9H21.5941V21.11H19.8841V23.15H21.3741V24.4H19.8841V28H18.0941Z",
    fill: "#E37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c02a499b87deed70a507a7f1633f317e.svg";
export { ForwardRef as ReactComponent };